import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getModules } from "../reducers/owner/owner.selectors";
type ExecuteFn = (name?: string, predicateFn?: (module: any) => boolean) => any;
export const useGetOwnerModules = (): [any, ExecuteFn] => {
  const modules = useSelector(getModules);
  const execute = useCallback((name = '', predicateFn) => modules.find(module => predicateFn ? predicateFn(module) : module.name === name), [modules]);
  return [modules, execute];
};